import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/InternDashboard.css';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const InternDashboard = () => {
  const navigate = useNavigate();
  const [assignments, setAssignments] = useState([]);
  const [certificateData, setCertificateData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [uploadedFiles, setUploadedFiles] = useState({});
  const [solutionFiles, setSolutionFiles] = useState({});
  const [submittedAssignments, setSubmittedAssignments] = useState({});
  useEffect(() => {
    const fetchAssignments = async () => {
      const internEmail = localStorage
        .getItem('internEmail')
        ?.trim()
        .toLowerCase();
      if (!internEmail) {
        navigate('/'); // redirect if not logged in
        return;
      }

      try {

        const response = await axios.get(`/api/intern/status/${internEmail}`);
        if (response.status === 200 && response.data) {
          const assignmentArray = ["assignment1", "assignment2", "assignment3", "assignment4"].map((key, index) => ({
            id: index + 1,
            key,
            name: `Assignment ${index + 1}`,
            status: response.data[key] || 'Pending',
          }));
          setAssignments(assignmentArray);
        } else {
          console.error('Error: unexpected response', response);
        }
      } catch (err) {
        console.error('Error fetching assignments:', err);
      } finally {
        setLoading(false);
      }
    };
    const fetchUploadedAssignments = async () => {
      try {

        const internEmail = localStorage
          .getItem("internEmail")
          ?.trim()
          .toLowerCase();

        const res = await axios.get(
          `/api/admin/assignments/${internEmail}`
        );
        console.log("FETCHED FILES:", res.data);
        setUploadedFiles(res.data);

      } catch (err) {
        console.error("Error fetching uploaded files:", err);
      }
    };
    fetchAssignments();
    fetchUploadedAssignments(); // ✅ ADD THIS
  }, [navigate]);
  const handleFileChange = (assignmentKey, file) => {
    setSolutionFiles((prev) => ({
      ...prev,
      [assignmentKey]: file,
    }));
  };
  const handleAssignmentSubmit = async (assignmentKey) => {
    try {
      const internEmail = localStorage
        .getItem("internEmail")
        ?.trim()
        .toLowerCase();

      const file = solutionFiles[assignmentKey];

      if (!file) {
        alert("Please select a file");
        return;
      }
      const MAX_SIZE = 20 * 1024 * 1024; // 20 MB

      if (file.size > MAX_SIZE) {
        alert(
          "File size exceeds the maximum limit of 20 MB.\n\nPlease compress your PDF, ZIP, or DOCX file and try again."
        );
        return;
      }
      const formData = new FormData();

      formData.append("solutionFile", file);
      formData.append("intern_email", internEmail);
      formData.append("assignment_key", assignmentKey);

      const res = await axios.post(
        "/api/submit-assignment",
        formData
      );

      alert(res.data.message);

      setSubmittedAssignments((prev) => ({
        ...prev,
        [assignmentKey]: true,
      }));

    } catch (err) {
      console.error(err);

      alert(
        err.response?.data?.message ||
        "Upload failed"
      );
    }
  };
  const allCompleted = assignments.length > 0 && assignments.every(a => a.status === 'Completed');

  const handleLogout = () => {
    localStorage.removeItem('internEmail');
    navigate('/');
  };
  // 🔥 Generate Certificate
  const generateCertificate = async () => {
    try {
      const internEmail = localStorage
        .getItem("internEmail")
        ?.trim()
        .toLowerCase();

      const res = await axios.get(
        `https://cveysolutions.in/api/certificate-by-email/${internEmail}`
      );

      const data = res.data;

      setCertificateData(data);

      setTimeout(async () => {
        await downloadPDF();
      }, 800);

    } catch (err) {
      console.error(err);
      alert("Error generating certificate");
    }
  };

  // 🔥 Download PDF
  const downloadPDF = async () => {
    const element = document.getElementById("certificate");

    const canvas = await html2canvas(element, {
      useCORS: true,
      scale: 3
    });
    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("landscape");
    pdf.addImage(imgData, "PNG", 10, 10, 280, 150);

    pdf.save(`${certificateData.student_name}_certificate.pdf`);
  };
  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner"></div>
        <h2>Loading your dashboard...</h2>
      </div>
    );
  }
  const BASE_URL = window.location.origin.includes("localhost")
    ? "http://localhost:5000"
    : "https://cveysolutions.in";
  return (
    <div className="intern-dashboard-container">
      <button className="logout-btn" onClick={handleLogout}>Logout</button>

      <div className="dashboard-card">
        <h1 className="title">Welcome, Intern! 👋</h1>
        <p className="subtitle">Download assignments and upload your solutions here.</p>
        <div className="assignments-list">
          {assignments.map((assignment, index) => {
            const file = uploadedFiles[assignment.key];

            if (!file) {
              return (
                <div
                  key={assignment.id}
                  className={`assignment-item ${index % 2 === 0 ? 'alt-bg-1' : 'alt-bg-2'}`}
                >
                  <div className="assignment-header">
                    <span className="assignment-name">
                      {assignment.name}
                    </span>

                    <button
                      className={`status-button ${assignment.status.toLowerCase()}`}
                    >
                      {assignment.status}
                    </button>
                  </div>

                  <div className="assignment-actions">
                    <a
                      href={`${BASE_URL}/uploads/${file}`}
                      target="_blank"
                      rel="noreferrer"
                      className="view-btn"
                    >
                      View Assignment
                    </a>
                  </div>

                  <div className="solution-upload-section">
                    <p className="file-note">
                      ⚠ Please make sure your uploaded file name starts with your name.
                      <br />
                      Example:
                      <span> Divya_Assignment1.pdf</span>
                    </p>

                    <p className="file-note">
                      ⚠ Allowed formats: PDF, ZIP, DOCX
                      <br />
                      ⚠ Maximum file size: 20 MB
                    </p>

                    <input
                      type="file"
                      onChange={(e) =>
                        handleFileChange(
                          assignment.key,
                          e.target.files[0]
                        )
                      }
                    />

                    <button
                      className="submit-solution-btn"
                      onClick={() =>
                        handleAssignmentSubmit(assignment.key)
                      }
                    >
                      Submit Solution
                    </button>

                    {submittedAssignments[assignment.key] && (
                      <p className="submitted-text">
                        Submitted Successfully ✅
                      </p>
                    )}
                  </div>
                </div>
              );
            }

            return (
              <div
                key={assignment.id}
                className={`assignment-item ${index % 2 === 0 ? 'alt-bg-1' : 'alt-bg-2'}`}
              >
                <span className="assignment-name">{assignment.name}</span>

                <button className={`status-button ${assignment.status.toLowerCase()}`}>
                  {assignment.status}
                </button>

                <a
                  href={`${BASE_URL}/uploads/${file}`}
                  target="_blank"
                  rel="noreferrer"
                  className="view-btn"
                >
                  View Assignment
                </a>
                <div className="solution-upload-section">
                  <p className="file-note">
                    ⚠ Please make sure your uploaded file name starts with your name.
                    <br />
                    Example:
                    <span> Divya_Assignment1.pdf</span>
                  </p>
                  <p className="file-note">
                    ⚠ Allowed formats: PDF, ZIP, DOCX
                    <br />
                    ⚠ Maximum file size: 20 MB
                  </p>
                  <input
                    type="file"
                    onChange={(e) =>
                      handleFileChange(
                        assignment.key,
                        e.target.files[0]
                      )
                    }
                  />

                  <button
                    className="submit-solution-btn"
                    onClick={() =>
                      handleAssignmentSubmit(assignment.key)
                    }
                  >
                    Submit Solution
                  </button>

                  {submittedAssignments[assignment.key] && (
                    <p className="submitted-text">
                      Submitted Successfully ✅
                    </p>
                  )}

                </div>
              </div>
            );
          })}
        </div>

        <button
          className={`generate-certificate-btn ${allCompleted ? 'enabled' : 'disabled'}`}
          disabled={!allCompleted}
          onClick={generateCertificate}
        >
          Generate Certificate
        </button>
      </div>
      {certificateData && (
        <div id="certificate" className="certificate-template">
          <div className="certificate-company-info">

            <div className="gstin">
              GSTIN : 37AAMCC5993P1ZK
            </div>

            <div className="cin">
              CIN : U70200AP2025PTC118711
            </div>

          </div>

          <div className="certificate-watermark"></div>

          <div className="certificate-header">
            <img
              src="/images/cvey-logo.jpg"
              alt="CVEY"
              className="certificate-logo left-logo"
            />

            <img
              src="/images/msme.png"
              alt="MSME"
              className="certificate-logo right-logo"
            />
          </div>
          <h2 className="company-name">
            CVEY SOLUTIONS PRIVATE LIMITED
          </h2>

          <p className="company-tagline">
            Your way to smarter solutions
          </p>


          <h1 className="certificate-title">
            CERTIFICATE
          </h1>

          <h2 className="certificate-subtitle">
            OF COMPLETION
          </h2>


          <h2 className="certificate-name">
            {certificateData.student_name}
          </h2>



          <p className="certificate-description">
            has successfully completed internship as
          </p>

          <h3 className="certificate-role">
            {certificateData.intern_type}
          </h3>

          <div className="certificate-number">
            Certificate Number:
            <span>{certificateData.certificate_number}</span>
          </div>

          <img
            src="/qr.png"
            alt="QR"
            className="certificate-qr"
          />

          <div className="achievement-badge">
            COMMITMENT<br />
            EXCELLENCE<br />
            SUCCESS
          </div>

          <div className="certificate-footer-section">

            <div className="footer-item">
              <strong>Issue Date</strong>
              <br />
              4th August 2026
            </div>

            <div className="signature-section">

              <img
                src="/images/signature.png"
                alt="Authorized Signature"
                className="signature-image"
              />

              <div className="signature-line"></div>

              <div className="signature-text">
                <strong>Authorized Signatory</strong>
                <br />
                CVEY Solutions Pvt. Ltd.
              </div>
            </div>

          </div>

        </div>
      )}
    </div>
  );
};

export default InternDashboard;
